module.exports = "//static.hsappstatic.net/conversations-internal-components/static-1.4266/img/visitor-widget/launcher-close-icon.svg"


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/conversations-visitor/node_modules/bender-webpack/lib/bender-url-loader.js!/usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/img/visitor-widget/launcher-close-icon.svg
// module id = 1007
// module chunks = 2 3